export const generateAppConfig = () => {
  let exportResult = {
    appRepoLocation: "https://sg-app.horizonsearesort.com.my",
    backendUrl: "http://localhost:3100",
    agentBackendUrl: "http://localhost:4041",
    jsReportUrl: "http://localhost:5488",
  };
  if (process.env.REACT_APP_PRODUCTION_MODE === "TEST") {
    exportResult.appRepoLocation = "https://sg-app.horizonsearesort.com.my";
    exportResult.backendUrl = "https://sg-api.horizonsearesort.com.my/admin";
    exportResult.agentBackendUrl =
      "https://sg-api.horizonsearesort.com.my/business";
    exportResult.userPortalBackendUrl =
      "https://sg-api.horizonsearesort.com.my/app";
    exportResult.jsReportUrl = "https://sg-report.horizonsearesort.com.my";
  }
  if (process.env.REACT_APP_PRODUCTION_MODE === "STAGE") {
    exportResult.appRepoLocation = "https://app.travoxis.com";
    exportResult.backendUrl = "https://admin-api.travoxis.com";
    exportResult.agentBackendUrl = "https://business-api.travoxis.com";
    exportResult.userPortalBackendUrl = "https://app-api.travoxis.com";
    exportResult.jsReportUrl = "https://report-test.summerbayresort.com.my";
  }
  if (process.env.REACT_APP_PRODUCTION_MODE === "PROD") {
    exportResult.appRepoLocation = "https://app.horizonsearesort.com.my";
    exportResult.backendUrl = "https://api.horizonsearesort.com.my/admin";
    exportResult.agentBackendUrl =
      "https://api.horizonsearesort.com.my/business";
    exportResult.userPortalBackendUrl =
      "https://api.horizonsearesort.com.my/app";
    exportResult.jsReportUrl = "https://report.horizonsearesort.com.my";
  }
  return exportResult;
};
